import { useCallback, useRef, useState } from 'react'
import { t } from '../../i18n'
import { AnimalsSecured } from '../../Types/AnimalStore'
import { HandleActionProp, Tab } from '../Tab'
import { TabItem } from '../Tab/TabItem'
import { AnimalInputData } from './AnimalInputData'
import { AnimalQuiz } from './AnimalQuiz'

type AnimalTabProps = {
  animal: AnimalsSecured
  setIsValid: (value: { [key: string]: boolean }, replace?: boolean) => void
  disabled?: boolean
}

export const AnimalTab = ({ animal, setIsValid, disabled }: AnimalTabProps) => {
  const animalTabRef = useRef<HandleActionProp>(null)
  const [disabledTabs, setDisabledTabs] = useState([1])

  const handleSetIsValid = useCallback(
    (value: { [key: string]: boolean }, replace?: boolean) => {
      setIsValid(value, replace)

      if (!value[`formAnimal${animal.id}`]) {
        setDisabledTabs([1])
      } else {
        setDisabledTabs([])
      }
    },
    [],
  )

  const handleNextTab = () => {
    if (animalTabRef.current) {
      animalTabRef.current.handleNextStep()
      setDisabledTabs([])
    }
  }

  return (
    <>
      <Tab
        ref={animalTabRef}
        disabledTabs={disabledTabs}
        tabs={[
          <TabItem
            label={t('pages.step1.animalInsuranceTable.tab.generalData')}
          />,
          <TabItem
            label={t('pages.step1.animalInsuranceTable.tab.questionnaires')}
          />,
        ]}
        pages={[
          <AnimalInputData
            key={`AnimalInputData-${animal.id}`}
            animal={animal}
            setIsValid={handleSetIsValid}
            disabled={disabled}
            onNextTab={handleNextTab}
          />,
          <AnimalQuiz
            key={`AnimalQuiz-${animal.id}`}
            animal={animal}
            setIsValid={setIsValid}
            disabled={disabled}
          />,
        ]}
      />
    </>
  )
}
